const initialState = {
  status: "invalid",
  filters: {
    open: true,
    query: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "REMARKS_TOGGLE_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, open: !state.filters.open },
      };
    case "REMARKS_SET_FILTERS_QUERY":
      return {
        ...state,
        filters: { ...state.filters, query: action.query },
      };
    case "REMARKS_SEARCHING":
      return {
        ...state,
        status: "searching",
      };
    case "REMARKS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "REMARKS_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action,
      };
    case "REMARKS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
